<div class="w-100" [ngClass]="customClass">
  @if (label.length > 1) {
    <app-cab-label [label]="label" [for]="id" [required]="required" />
  }

  <textarea
    class="cab-textarea-field"
    [formControl]="formControl"
    [id]="id"
    [placeholder]="placeholder | translate"
    [rows]="rows"
  ></textarea>

  @if (showValidationErrors()) {
    <div class="text-danger" [innerHTML]="errorMessagesHtml()"></div>
  }
</div>
